__turbopack_context__.v({
  "error": "CreateWalletConfirm-module__1An65q__error",
  "grid": "CreateWalletConfirm-module__1An65q__grid",
  "removeWordIcon": "CreateWalletConfirm-module__1An65q__removeWordIcon",
  "root": "CreateWalletConfirm-module__1An65q__root",
  "selectWord": "CreateWalletConfirm-module__1An65q__selectWord",
  "selectWordLabel": "CreateWalletConfirm-module__1An65q__selectWordLabel",
  "selectWords": "CreateWalletConfirm-module__1An65q__selectWords",
  "success": "CreateWalletConfirm-module__1An65q__success",
  "successIcon": "CreateWalletConfirm-module__1An65q__successIcon",
  "word": "CreateWalletConfirm-module__1An65q__word",
  "wordLabel": "CreateWalletConfirm-module__1An65q__wordLabel",
  "wordLabelError": "CreateWalletConfirm-module__1An65q__wordLabelError",
  "wordLabelSuccess": "CreateWalletConfirm-module__1An65q__wordLabelSuccess",
  "wordNumber": "CreateWalletConfirm-module__1An65q__wordNumber",
});
